export { default } from './Renegociacao25Canais';
